import { Token, TokenDeliveryMethod, TokenType } from 'common/models/Token';
import { SignatureScope } from 'common/models/Transaction';
import { apiClient, ApiClientResponse, PaginatedResponse } from '../services/api-client';

export enum TokenState {
  DEFAULT = 'default',
  DELIVERED = 'code-delivered',
  DELIVERY_ERROR = 'error-deliver-code',
  REQUESTED = 'code-requested',
  SUBMISSION_ERROR = 'error-submit-code',
  SUBMITTED = 'code-submitted',
  VERIFIED = 'verified',
}

export default {
  create: (
    transactionId: string,
    type: TokenType,
    deliveryMethod: TokenDeliveryMethod,
    scopes?: SignatureScope[],
  ): Promise<ApiClientResponse<void>> =>
    apiClient.post(`/tokens/${type}/${deliveryMethod}`, {
      transactionId,
      scopes,
    }),
  find: (query?: Record<string, unknown>): Promise<ApiClientResponse<PaginatedResponse<Token>>> =>
    apiClient.get(`/tokens`, {
      params: {
        $limit: -1,
        $sort: { updatedAt: -1 },
        ...query,
      },
    }),
  verify: (
    transactionId: string,
    type: TokenType,
    deliveryMethod: TokenDeliveryMethod,
    deliveryDetail: string,
    code: string,
  ): Promise<ApiClientResponse<{ attemptsLeft?: number }>> =>
    apiClient.post(`/tokens/${type}/${deliveryMethod}/verify`, {
      transactionId,
      deliveryDetail,
      code,
    }),
};
